import React from "react";
import Helmet from "react-helmet";
import { GlobalStyles } from "twin.macro";
import { createGlobalStyle } from "styled-components";

import { ParallaxProvider } from "react-scroll-parallax";
import { ModalProvider } from "./ModalContext";

import SEO from "./SEO";
import Modal from "./Modal";
import Footer from "./Footer";
import Header from "./Header";
import CTC from "./CTC";

//? Example font imports:
import EngraversGothicBTWoff2 from "../fonts/engravers-gothic.woff2";
import EngraversGothicBTOTF from "../fonts/engravers-gothic.otf";
import MazuisReviewItalicWoff2 from "../fonts/mazuis-review-italic.woff2";
import MazuisReviewItalicOTF from "../fonts/mazuis-review-italic.otf";
import MazuisReviewRegularOTF from "../fonts/mazuis-review-regular.otf";
import MazuisReviewRegularWoff2 from "../fonts/mazuis-review-regular.woff2";

//? How to add a font (in CustomStyles):
/* @font-face {
    font-family: 'Stay Wild';
    src:  url(${StayWildWoff2}) format('woff2'),
          url(${StayWildOTF}) format('opentype');
    font-style: normal;
    font-weight: normal;
    font-display: swap;
    text-rendering: optimizeLegibility;
  } */

/*
 * Here you can add global styles. Especially useful for managing body overflow
 * or adding custom fonts.
 */
const CustomStyles = createGlobalStyle`
 :root {
    @media (min-width: 2000px) {
      font-size: 20px;
    }
    @media (min-width: 3000px) {
      font-size: 24px;
    }
  }
	
  body {
    font-family: "Montserrat", "sans-serif";
		-webkit-tap-highlight-color: transparent; // Remove mobile tap highlight

		.liveChatFloatingButton {
			display: none !important;
		}
  }
	@font-face {
		font-family: 'Engravers Gothic BT';
		src: url('${EngraversGothicBTWoff2}') format('woff2'),
				url('${EngraversGothicBTOTF}') format('opentype');
		font-style: normal;
		font-weight: normal;
		font-display: swap;
		text-rendering: optimizeLegibility;
	}
	@font-face {
		font-family: 'Mazuis Review Italic';
		src: url('${MazuisReviewItalicWoff2}') format('woff2'),
				url('${MazuisReviewItalicOTF}') format('opentype');
		font-style: italic;
		font-weight: normal;
		font-display: swap;
		text-rendering: optimizeLegibility;
	}

	@font-face {
		font-family: 'Mazuis Review Regular';
		src: url('${MazuisReviewRegularWoff2}') format('woff2'),
				url('${MazuisReviewRegularOTF}') format('opentype');
		font-style: normal;
		font-weight: normal;
		font-display: swap;
		text-rendering: optimizeLegibility;
	}
`;

/*
 *  This is a layout component. Add partials that should appear on
 *  every page using this layout, such as footers and navigation.
 *  Remove the Modal component if it is never used, it will be included
 *  in the bundle and slow pagespeed scores.
 */
const Layout = ({ children, contact, seo, inner, schemaCodes }) => {
  // if (!seo && window && window === undefined)
  //   console.warn(`Require prop "seo" not present.`);
  return (
    <ModalProvider>
      <ParallaxProvider>
        <Helmet htmlAttributes={{ lang: "en-US" }} />
        <GlobalStyles />
        <CustomStyles />
        <Modal />
        {seo && <SEO seo={seo} schemaCodes={schemaCodes} />}
        <Header inner={inner} />
        <main>{children}</main>
        <Footer contact={contact} h1={contact} />
        <CTC />
      </ParallaxProvider>
    </ModalProvider>
  );
};

export default Layout;
